"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goldFurnaceConfig = void 0;
exports.goldFurnaceConfig = {
    name: 'gold-furnace',
    fullname: 'Gold Furnace',
    description: 'Converts gold ore into gold ingots.',
    type: 'factory',
    width: 1,
    height: 1,
    levelMax: 4,
    canBeDisabled: true,
    requiredTechnology: 'gold',
    levels: [
        { level: 0, constructionCosts: {}, time: 1000, provides: { gold: 1 }, costs: { energy: 1, 'gold-ore': 1 }, stores: {} },
        { level: 1, constructionCosts: { iron: 30, stone: 30 }, time: 800, provides: { gold: 1 }, costs: { energy: 1, 'gold-ore': 1 }, stores: {} },
        { level: 2, constructionCosts: { iron: 50, stone: 50 }, time: 600, provides: { gold: 1 }, costs: { energy: 1, 'gold-ore': 1 }, stores: {} },
        { level: 3, constructionCosts: { gold: 50, copper: 50, iron: 50, stone: 50 }, time: 300, provides: { gold: 1 }, costs: { energy: 1, 'gold-ore': 1 }, stores: {} },
        { level: 4, constructionCosts: { gold: 100, copper: 100, iron: 100, stone: 100 }, time: 100, provides: { gold: 1 }, costs: { energy: 1, 'gold-ore': 1 }, stores: {} },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/goldfurnace.js
// module id = r5lu
// module chunks = 0